import { useLocation } from "react-router";

import { ScrollRestorer as SharedScrollRestorer } from "../shared/ScrollRestorer";

export const ScrollRestorer = () => {
  const location = useLocation();

  return <SharedScrollRestorer location={location} />;
};
